import { DeleteIcon } from "@/assets/icons";
import { LoadingButton } from "@altimateai/lego";
import { Popconfirm } from "@altimateai/lego";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteTag } from "@/helpers/apis";
import { toast } from "@altimateai/lego";
import { TAGS_QUERY_KEY } from "../useTags";
import { SettingsTracking } from "@/lib/tracking/settings";

interface Props {
  id: string;
  name: string;
}

const DeleteTag = ({ id, name }: Props) => {
  const queryClient = useQueryClient();
  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: () => deleteTag(id),
    onSuccess: () => {
      SettingsTracking.tagDeleted(id);
      queryClient.invalidateQueries({ queryKey: [TAGS_QUERY_KEY] });
      toast({ description: "Tag deleted successfully" });
    },
    onError: (error: Error) => {
      toast({
        description: `Failed to delete tag: ${error.message || error}`,
        variant: "destructive",
      });
    },
  });

  return (
    <Popconfirm
      title={`Delete ${name}`}
      description={`Are you sure to delete ${name}?`}
      onConfirm={e => {
        e?.stopPropagation();
        mutate();
      }}
      onCancel={e => {
        e?.stopPropagation();
      }}
      okText="Yes"
      cancelText="No"
    >
      <LoadingButton
        title={`Delete ${name}`}
        loading={isLoading}
        variant="ghost"
        className="al-border-0 al-p-0 al-h-[14px]"
      >
        <DeleteIcon className="h-4 w-4 al-text-destructive" />
      </LoadingButton>
    </Popconfirm>
  );
};

export default DeleteTag; 